// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__259on","newExpiryDate":"styles_newExpiryDate__3_E6W","footer":"styles_footer__3in6u"};